import React from 'react'

const Shibig = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="50"
            height="50"
            fill="none"
            viewBox="0 0 50 50"
        >
            <path
                fill="#E42D04"
                fillRule="evenodd"
                d="M25 50C11.25 50 0 38.75 0 24.875.125 11.125 11.25-.123 25.125.002 38.875.126 50 11.251 50 25.251 49.875 38.874 38.75 50 25 50z"
                clipRule="evenodd"
            ></path>
            <path
                fill="#fff"
                fillRule="evenodd"
                d="M25.487 43.333c1.814 0 6.47-.818 10.572-4.09 4.717-3.763 5.161-5.86 5.448-7.214.025-.118.049-.23.074-.337a4.24 4.24 0 00.085-.805c-.99-.16-2.38-.253-4-.06-2.65.314-4.734 2.124-5.444 2.989-.394-1.967-2.32-5.9-6.864-5.9-4.544 0-6.995 3.933-7.652 5.9-.42-.734-1.988-2.36-4.891-2.99a9.139 9.139 0 00-4.482.131c.089 1.463.57 3.022 1.848 4.668 2.202 2.832 5.617 4.58 7.14 5.36.17.087.316.162.434.225 1.184.629 4.418 2.123 7.732 2.123z"
                clipRule="evenodd"
            ></path>
            <path
                fill="#FFAA35"
                fillRule="evenodd"
                d="M41.663 30.83a14.62 14.62 0 00-3.998-.06c-2.65.313-4.731 2.117-5.44 2.98-.395-1.96-2.319-5.882-6.86-5.882-4.542 0-6.992 3.921-7.649 5.882-.42-.732-1.987-2.353-4.888-2.98a9.152 9.152 0 00-4.48.13c-.08-1.33.166-2.579.429-3.738.441-1.945 1.55-4.523 2.05-5.569-.447-1.072-1.482-4.11-2.05-7.686-.568-3.577.394-5.987.946-6.745.894.235 3.028.972 4.415 2.039 1.388 1.067 3.522 3.425 4.416 4.47 1.156-.313 4.132-.94 6.78-.94 2.65 0 5.205.627 6.151.94.788-.94 2.728-3.152 4.179-4.47 1.45-1.318 3.81-1.96 4.81-2.118.262.34.82 1.334.946 2.589.158 1.568-.316 4.862-.946 7.058a164.655 164.655 0 01-1.42 4.628c.132.287.584 1.223 1.34 2.666.803 1.53 1.322 4.98 1.269 6.805z"
                clipRule="evenodd"
            ></path>
            <path
                fill="#000"
                d="M28.724 37.81c-.188.25-.39.73-.469.94v-.078l-.234-1.882a25.84 25.84 0 01-2.657.157c-1.062 0-2.317-.105-2.812-.157l-.078 1.882a5.756 5.756 0 01-.313-.55c-.156-.313-.703-.783-.703-1.019 0-.188-.26-.6-.39-.784l-.235-.313h1.406l.313.235c.26-.026.922-.047 1.484.078.563.126.912-.365 1.016-.627v-1.254c-.235-.157-.813-.518-1.25-.706-.547-.235-1.094-1.176-.938-2.117.157-.94.625-1.254.938-1.176.312.079 2.344-.078 2.656 0 .313.079.86.235 1.094.628.234.392.078 1.96-.39 2.508-.376.44-1.095.758-1.407.863v1.254c0 .157.547.55.625.627.078.079 1.25 0 1.484 0 .188 0 .339-.156.391-.235h1.328v.314c0 .157-.234.862-.312.94-.079.08-.313.157-.547.471z"
            ></path>
            <path
                fill="#000"
                d="M26.21 37.292l-.794.625-.634-.625-.556.277-.476-.486h3.333l-.476.556-.397-.347zM17.669 24.471a14.66 14.66 0 00-2.325-.721c-.103.053-.31.224-.31.48 0 .321-.077.642 0 1.283.078.64.698 1.041 1.782 1.522 1.085.481 2.945.882 4.262.882 1.317 0 .078-1.363-.387-1.683-.465-.32-1.86-1.282-3.022-1.763z"
            ></path>
            <path
                fill="#fff"
                d="M18.941 22.345c-.695.124-1.658.155-2.053.155-.395-.052-1.232-.295-1.421-.854-.237-.7.395-1.476 1.184-1.864.79-.389 1.817-.233 2.448.699.632.932.71 1.708-.158 1.864z"
            ></path>
            <path
                fill="#000"
                d="M33.164 24.055a14.67 14.67 0 012.325-.722c.103.054.31.225.31.481 0 .32.077.641 0 1.282-.078.641-.698 1.042-1.782 1.523-1.085.48-2.945.881-4.262.881-1.317 0-.078-1.362.387-1.683.465-.32 1.86-1.282 3.022-1.762z"
            ></path>
            <path
                fill="#fff"
                d="M30.642 22.345c.695.124 1.658.155 2.053.155.395-.052 1.232-.295 1.421-.854.237-.7-.395-1.476-1.184-1.864-.79-.389-1.817-.233-2.448.699-.632.932-.71 1.708.158 1.864z"
            ></path>
            <path
                fill="#FF8C30"
                d="M13.512 16.531c-.568.62-1.656 2.016-2.13 2.636-.315-.672-1.009-2.466-1.261-4.264s-.053-4.574.079-5.736c.341.025 1.34.31 2.602 1.24 1.262.93 3.102 2.661 3.864 3.41-.814.647-2.586 2.094-3.154 2.714z"
            ></path>
            <path
                fill="#FF9A32"
                fillRule="evenodd"
                d="M10 10.643c1.24.518 2.873 1.309 3.557 2.024.694.725 1.304 1.685 1.667 2.333a76.55 76.55 0 011.442-1.166c-.77-.752-2.63-2.49-3.907-3.423-1.276-.933-2.286-1.218-2.631-1.244-.041.362-.09.88-.128 1.476z"
                clipRule="evenodd"
            ></path>
            <path
                fill="#FF8C30"
                d="M36.071 16.531c.568.62 1.656 2.016 2.13 2.636.315-.672 1.009-2.466 1.261-4.264s.053-4.574-.079-5.736c-.342.025-1.34.31-2.602 1.24-1.262.93-3.102 2.661-3.864 3.41.814.647 2.586 2.094 3.154 2.714z"
            ></path>
            <path
                fill="#FF9A32"
                fillRule="evenodd"
                d="M39.583 10.643c-1.24.518-2.872 1.309-3.557 2.024-.694.725-1.304 1.685-1.667 2.333a76.838 76.838 0 00-1.443-1.166c.771-.752 2.632-2.49 3.908-3.423 1.276-.933 2.285-1.218 2.631-1.244.041.362.09.88.128 1.476z"
                clipRule="evenodd"
            ></path>
        </svg>
    )
}

export default Shibig